import AdminApi from '../../services/api'
import swal from 'sweetalert2';
import session from "../../services/session";
import CONFIG_COMPANY from "../../services/myConfig";
import Loc from "../../services/localization";
import {integer} from "vee-validate/dist/rules.esm";
import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";

const AdminApiService = new AdminApi()
const LocService = new Loc()

export default {
    data() {
        return {
            locale: LocService,
            filter: '',
            debtor: false,
            messageTitle: '',
            messageText: '',
            sendByEmail: false,
            sendByNotification: false,
            showFilters: false,
            onlyExpireUsers: false,
            paymentsInRow: null,
            isEnableGender: false,
            additionalTypes: [],
            hiddenColumns: CONFIG_COMPANY.HIDDEN_COLUMNS_USER_TABLE ,
            namesForPartner: LocService.t('label_name_for_partner'),
            allCustomCategories: [],
            selectedCustomCategories: [],
            selectedLoyalties: [],
            selectedGender: null,
            users: [],
            selectedUsers: [],
            selectedUsersIds: [],
            types: [],
            expireFromMonths: null,
            expireFromMonthsList: [
                {
                    label: LocService.t('label_active_users'),
                    number: -1
                },
                {
                    label: LocService.t('label_active_users_last_30_days'),
                    number: -2
                },
                {
                    label: LocService.t('label_not_active_users'),
                    number: 0
                },
                {
                    label: LocService.t('label_not_active_more') + ' ' +LocService.t('label_not_active_more_3'),
                    number: 3
                },
                {
                    label: LocService.t('label_not_active_more') + ' ' + LocService.t('label_not_active_more_6'),
                    number: 6
                },

            ],
            visibleUsersId: [],
            showImagePreview: false,
            imageToPreview: "",
            imageToPreviewUserId: 0,
            useProfilePictures: false,
            loyaltyProgramsEnabled: false,
            loyaltyPrograms: null,
            loyaltyProgramsList: [],
            maxLoyaltyProgram: 0,
            customCategory: '',
            customCategories: [],
            visibleCustomConfig: false,
            partnerCompanies: [],
            selectedPartnerCompany: null,
            isVisiblePartnerReport: false,
            pagination: {
                page: 1,
                limit: 100,
                totalCount: 0
            }
        }
    },
    computed: {
        filteredUsers() {
            if(this.onlyExpireUsers){
                return this.users.filter(item => {
                    return (item.name.toLowerCase().indexOf(this.filter.toLowerCase()) > -1 ||
                        item.surname.toLowerCase().indexOf(this.filter.toLowerCase()) > -1 ||
                        item.username.toLowerCase().indexOf(this.filter.toLowerCase()) > -1 ||
                        item.email.toLowerCase().indexOf(this.filter.toLowerCase()) > -1 ||
                        item.phone.toLowerCase().indexOf(this.filter.toLowerCase()) > -1) &&
                        !this.isActiveMemberShip(item)

                })
            }
            return this.users;
            // return this.users.filter(item => {
            //     return item.name.toLowerCase().indexOf(this.filter.toLowerCase()) > -1 ||
            //         item.surname.toLowerCase().indexOf(this.filter.toLowerCase()) > -1 ||
            //         item.username.toLowerCase().indexOf(this.filter.toLowerCase()) > -1 ||
            //         item.email.toLowerCase().indexOf(this.filter.toLowerCase()) > -1 ||
            //         item.phone.toLowerCase().indexOf(this.filter.toLowerCase()) > -1
            //
            // })
        }
    },
    methods: {
        load: load,
        formatDate: formatDate,
        capitalizeFirstLetter: capitalizeFirstLetter,
        addUser: addUser,
        deleteUser: deleteUser,
        getDisplayLoyalty: getDisplayLoyalty,
        loyaltyStyle: loyaltyStyle,
        reset: reset,
        editUser: editUser,
        setTrainingNumber: setTrainingNumber,
        setAdditionalServices: setAdditionalServices,
        isActiveMemberShip: isActiveMemberShip,
        getStyleActiveMembership: getStyleActiveMembership,
        getDebtorStyle: getDebtorStyle,
        externalPartnerPdf: externalPartnerPdf,
        loadCompanyPartner: loadCompanyPartner,
        getUserStyleTr: getUserStyleTr,
        getChipClassExpire: getChipClassExpire,
        isSelectedExpire: isSelectedExpire,
        onClickExpireMonth: onClickExpireMonth,
        keymonitor: keymonitor,
        clickSearch: clickSearch,
        plusTraining: plusTraining,
        minusTraining: minusTraining,
        addNotArrival: addNotArrival,
        removeNotArrival: removeNotArrival,
        getNotArrivalStyle: getNotArrivalStyle,
        getChipClassCustomCategory: getChipClassCustomCategory,
        isSelectedCustomCategory: isSelectedCustomCategory,
        clickSelectCustomCategory: clickSelectCustomCategory,
        getChipClassLoyalty: getChipClassLoyalty,
        isSelectedLoyalty: isSelectedLoyalty,
        clickSelectLoyalty: clickSelectLoyalty,
        onClickUser: onClickUser,
        onClickTrainingTypes: onClickTrainingTypes,
        openImage: openImage,
        getTrainingTypes: getTrainingTypes,
        onChangeCheckUser: onChangeCheckUser,
        setSelectedCheckUser: setSelectedCheckUser,
        sendCampaign: sendCampaign,
        resetFilters: resetFilters,
        isAnyFilterActive: isAnyFilterActive,
        isMobile() {
            return window.innerWidth <= 850; // Adjust the breakpoint as needed
        },
        onupdate(data, user){
            console.log(data)
            // user.showMore = data;
            if(data){
                this.visibleUsersId.push(user.id)
            }else{
                console.log('false je ')
                this.visibleUsersId = this.visibleUsersId.filter(u => u !== user.id)
            }
            console.log(this.visibleUsersId)
        }
    },
    created() {
        let _self = this;
        this.$topnavbar.$on('closeShowImage', () => {
            _self.showImagePreview = false;
        });
    },
    beforeMount() {
        if (session.getRole() !== 'ROLE_ADMIN' && session.getRole() !== 'ROLE_SUPER_ADMIN') {
            this.$router.push(CONFIG_COMPANY.HOME);
            return;
        }
        this.allCustomCategories = session.getConfig().customCategories.split(";").filter(e => e.length > 0);
        this.useProfilePictures = session.getConfig().useProfilePictures == null ? true : session.getConfig().useProfilePictures;
        this.loyaltyProgramsEnabled = session.getConfig().loyaltyPrograms != null && session.getConfig().loyaltyPrograms.length > 0;
        this.loyaltyPrograms = session.getConfig().loyaltyPrograms;
        if(session.getConfig().loyaltyPrograms != null && session.getConfig().loyaltyPrograms.length > 0){
            let temp = this.loyaltyPrograms.split(";")
            this.loyaltyProgramsList = [];
            temp.forEach(t => {
                this.loyaltyProgramsList.push(parseInt(t));
            })
            this.maxLoyaltyProgram = Math.max(...this.loyaltyProgramsList);
        }
        if(session.getConfig().additionalServiceTypes != null && session.getConfig().additionalServiceTypes.length > 0){
            this.additionalTypes = session.getConfig().additionalServiceTypes.split(";").filter(e => e.length > 0)
        }
        this.customCategory = session.getConfig().customCategory == null ? '' : session.getConfig().customCategory
        if(session.getConfig().customCategories != null){
            this.customCategories = session.getConfig().customCategories.split(";")
        }
        this.visibleCustomConfig = this.customCategory.length > 0 && this.customCategories.length > 0;
        this.isEnableGender = CONFIG_COMPANY.ENABLE_GENDER != null ? CONFIG_COMPANY.ENABLE_GENDER : false;
        this.load()
        this.getTrainingTypes()
        this.loadCompanyPartner();
    },
    watch: {
        'filter': function (newVal) {
            if (newVal.length === 0){
                this.pagination.page = 1;
                this.load();
            }
        },
        'debtor': function (newVal) {
            this.load();
        },
        'selectedGender': function (newVal) {
            this.load();
        },
        'onlyExpireUsers': function (newVal) {

        },

        'selectedPartnerCompany': function (newVal) {
            this.load();
        },
    }
}



function loadCompanyPartner() {
    let _self = this;

    AdminApiService.getCompanyPartners()
        .then((response) => {
            _self.partnerCompanies = response.data
        })
        .catch(error => {
            swal(LocService.t('label_error'), error.data.localized_error_message, 'error')
        })
}


function openImage(image, userId){
    this.imageToPreview = image;
    this.imageToPreviewUserId = userId;
    this.showImagePreview = true;
}

function clickSearch() {
    this.pagination.page = 1;
    this.load()
}

function load() {
    let _self = this;
    let customCategory = this.selectedCustomCategories.length === 0 ? null : this.selectedCustomCategories[0];
    let paymentsInRow = this.selectedLoyalties.length === 0 ? null : this.selectedLoyalties[0];

    let request = {
        page: _self.pagination.page,
        limit: _self.pagination.limit,
        filter: _self.filter,
        debtor: _self.debtor,
        gender: _self.selectedGender,
        paymentsInRow: paymentsInRow != null ? parseInt(''+paymentsInRow, 10) : null,
        expireFromMonths: _self.expireFromMonths,
        customCategory: customCategory,
        partnerCompany: _self.selectedPartnerCompany
    }

    this.isVisiblePartnerReport = false

    AdminApiService.getUsers(request)
        .then((response) => {
            _self.users = response.data.results;
            _self.users.forEach(u => {
                u.showMore = false;
                u.checked = _self.selectedUsersIds.indexOf(u.id) > -1
            })
            _self.pagination.totalCount = response.data.totalCount;
            _self.isVisiblePartnerReport = _self.selectedPartnerCompany != null && _self.users.length > 0
        })
        .catch((error) => {
            swal( LocService.t('label_error'), error.data.localized_error_message, 'error')
        })
}

function editUser(user) {
    this.$router.push('/edit-user?id=' + user.id)

}


function deleteUser(user) {
    let _self = this;

    swal({
        title: LocService.t('label_are_you_sure'),
        text: LocService.t('label_are_you_sure_to_delete_user')  + ": " + user.name,
        type: 'warning',
        showCancelButton: true,
        cancelButtonText: LocService.t('label_no'),
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: LocService.t('label_yes'),
        customClass: 'swal2-warning'
    }).then(function () {
        AdminApiService.deleteUser(user.id)
            .then((response) => {
                swal( LocService.t('label_success'), LocService.t('label_user_deleted_success'), 'success')
                _self.load()
            })
            .catch((error) => {
                swal( LocService.t('label_error'), error.data.localized_error_message, 'error')
            })
    });


}

function addUser() {
    this.$router.push('/add-user')
}

function formatDate(date) {
    return this.$moment(new Date(date * 1000)).format('DD-MM-YYYY')
}

function getUserStyleTr(user) {
    if (user.debtor) {
        return "color: red;"
    }
    return "";
}

function keymonitor(event) {
    if (event.key === 'Enter') {
        this.load();
    }
}

function minusTraining(user) {
    let _self = this;
    swal({
        title:  LocService.t('label_are_you_sure'),
        text:  LocService.t('label_are_you_sure_to_remove_training_to_user') + ": " + user.name +"?",
        type: 'warning',
        showCancelButton: true,
        cancelButtonText: LocService.t('label_no'),
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: LocService.t('label_yes'),
        customClass: 'swal2-warning'
    }).then(function () {
        AdminApiService.minusTraining(user.id)
            .then((response) => {
                swal( LocService.t('label_success'),  LocService.t('label_training_removed_success'), 'success')
                _self.load()
            })
            .catch((error) => {
                swal( LocService.t('label_error'), error.data.localized_error_message, 'error')
            })
    });

}

function plusTraining(user) {
    let _self = this;
    swal({
        title:  LocService.t('label_are_you_sure'),
        text: LocService.t('label_are_you_sure_to_add_training_to_user') + ": " + user.name +"?",
        type: 'warning',
        showCancelButton: true,
        cancelButtonText: LocService.t('label_no'),
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: LocService.t('label_yes'),
        customClass: 'swal2-warning'
    }).then(function () {
        AdminApiService.plusTraining(user.id)
            .then((response) => {
                swal( LocService.t('label_success'),  LocService.t('label_training_add_success'), 'success')
                _self.load()
            })
            .catch((error) => {
                swal( LocService.t('label_error'), error.data.localized_error_message, 'error')
            })
    });
}

function onClickUser(user) {
    if(this.hiddenColumns.includes('DISABLE_USER_INFO')) return
    let username = LocService.t('label_username')
    let email = LocService.t('label_email')
    let phone = LocService.t('label_phone')
    let restOfTrainings = LocService.t('label_rest_of_trainings')
    swal({
        title: ''+user.name + ' '+ user.surname,
        html : '<html><div class="foo">' +
            '<br><div><b>' + username +':</b>&ensp;'+ user.username+'</div><br>'+
            '<div><b>' + email +':</b>&ensp;'+ user.email+'</div><br>'+
            '<div><b>' + phone +':</b>&ensp;'+ user.phone+'</div><br>'+
            '<div><b>' + restOfTrainings +':</b>&ensp;'+ user.restOfTraining+'</div><br>'+

            '</div></html>',
        text: "",
        showCancelButton: false,
        confirmButtonColor: '#3085d6',
        confirmButtonText: LocService.t('label_close'),
        customClass: 'swal2-warning'
    }).then(function () {

    });
}

function onClickTrainingTypes(user) {
    let _self = this;
    var html = '<html><div class="foo">';
    for(var i in this.types) {
        let item = i;
        var checkedString = '';
        if(user.trainingTypes.includes(i)) {
            checkedString = 'checked'
        }
        html += '<div> ' +
            '<input id="'+ item +'" style="color: black; " type="Checkbox" name="key" value="key" ' + checkedString + ' >' +
            '&nbsp;<label for="'+ item+'" style="color: black; font-size: 18px;">'+ item +'</label>&nbsp;&nbsp;&nbsp;' +
            '</div>'
    }

    html += '</div></html>';
    swal({
        title: LocService.t('label_choose_trainings'),
        html: html,
        text: "",
        showCancelButton: true,
        cancelButtonText: LocService.t('label_close'),
        cancelButtonColor : '#d33',
        confirmButtonColor: '#3085d6',
        confirmButtonText: LocService.t('label_save'),
        customClass: 'swal2-warning'
    }).then(function () {
        let types = [];
        for(var i in _self.types) {
            let isChecked = document.getElementById(i).checked
            if(isChecked) types.push(i)
        }
        let model = {
            trainingTypes: types
        };
        AdminApiService.updateTrainingTypes(model, user.id)
            .then(() => {
                _self.load()
            })
            .catch(error => {
                swal( LocService.t('label_error'), error.data.localized_error_message, 'error')
            })
    });
}


function getNotArrivalStyle(notArrival) {
    if(notArrival <= 0){
        return ""
    }else if(notArrival === 1){
        return "background: purple;"
    }else{
        return "background: red;"
    }
}

function addNotArrival(userId) {
    let _self = this;
    AdminApiService.addNotArrival(userId)
        .then((response) => {
            _self.load()
        })
        .catch(error => {
            swal( LocService.t('label_error'), error.data.localized_error_message, 'error')
        })
}

function removeNotArrival(userId) {
    let _self = this;
    AdminApiService.removeNotArrival(userId)
        .then((response) => {
            _self.load()
        })
        .catch(error => {

            swal( LocService.t('label_error'), error.data.localized_error_message, 'error')
        })
}

function getTrainingTypes() {
    let _self = this;
    AdminApiService.getTrainingTypes()
        .then((response) => {
            _self.types = response.data
        })
        .catch(error => {
            swal( LocService.t('label_error'), error.data.localized_error_message, 'error')
        })
}

function capitalizeFirstLetter(str) {
    return str.charAt(0).toUpperCase() + str.slice(1);
}

function getDebtorStyle(user){
    if(user.debtor){
        return 'color: red;'
    }
    return '';
}

function isActiveMemberShip(user){
    var currentDate = new Date();
    currentDate.setHours(0, 0, 0, 0);
    const currentTimeInMilliseconds = currentDate.getTime();
    if(currentTimeInMilliseconds > (user.expireDate * 1000 + 10800000)){
        return false;
    }else{
        return true;
    }
}

function getStyleActiveMembership(user){
    if(!this.isActiveMemberShip(user)){
        return 'color: red;'
    }
    return '';
}

function getDisplayLoyalty(user){
    if(this.loyaltyPrograms == null || this.loyaltyPrograms.length <= 0) return '/';
    // return user.paid
    return user.paidMonthsInRow + '/' + this.maxLoyaltyProgram;
}


function loyaltyStyle(maxItem, userPaidMonthsInRow){
    return userPaidMonthsInRow >= maxItem ? 'color: green;' : 'color: red;'
}

function setTrainingNumber(userId, trainings) {
    let _self = this
    swal({
        title: LocService.t("label_set_trainings_number"),
        html : '<html><div class="foo">' +
            '<br>' +
            '<input id="swal-input" type="number" placeholder="'+ LocService.t("label_set_trainings_number") +'" class="input" style="width: 50%; border-radius: 10px" value="'+ trainings +'" />' +
            '' +
            '<br>'+
            '</div></html>',
        text: "",
        showCancelButton: false,
        showConfirmButton: true,
        confirmButtonColor: '#3085d6',
        confirmButtonText: LocService.t("label_save"),
        customClass: 'swal2-warning'
    }).then(function () {
        var trainingsNumber = document.getElementById('swal-input').value
        var num = parseInt(trainingsNumber)

        swal({
            title: "",
            text: "",
            type: "",
            // html: "<div style='position: relative'><div class=\"loader\"></div></div>",
            html: "<div style='margin-top: 20%;' class=\"lds-roller\"><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div></div><div>Molimo sačekajte</div>",
            showCancelButton: false,
            showConfirmButton: false,
            allowOutsideClick: false,
            allowEscapeKey: false,
            customClass: 'swal-custom'
        }, function (selection) {});

        AdminApiService.setTrainingNumber(userId, num)
            .then((response) => {
                _self.load()
                swal.close()
            })
            .catch(error => {
                console.log(error)
                swal(LocService.t("label_error"), error.data.localized_error_message, 'error')
            })
    });

}

function setAdditionalServices(userId, trainings) {
    let _self = this
    swal({
        title: LocService.t("label_additional_payment"),
        html : '<html><div class="foo">' +
            '<br>' +
            '<input id="swal-input" type="number" placeholder="'+ LocService.t("label_additional_payment") +'" class="input" style="width: 50%; border-radius: 10px" value="'+ trainings +'" />' +
            '' +
            '<br>'+
            '</div></html>',
        text: "",
        showCancelButton: false,
        showConfirmButton: true,
        confirmButtonColor: '#3085d6',
        confirmButtonText: LocService.t("label_save"),
        customClass: 'swal2-warning'
    }).then(function () {
        var trainingsNumber = document.getElementById('swal-input').value
        var num = parseInt(trainingsNumber)

        swal({
            title: "",
            text: "",
            type: "",
            // html: "<div style='position: relative'><div class=\"loader\"></div></div>",
            html: "<div style='margin-top: 20%;' class=\"lds-roller\"><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div></div><div>Molimo sačekajte</div>",
            showCancelButton: false,
            showConfirmButton: false,
            allowOutsideClick: false,
            allowEscapeKey: false,
            customClass: 'swal-custom'
        }, function (selection) {});

        AdminApiService.setAdditionalServices(userId, num)
            .then((response) => {
                _self.load()
                swal.close()
            })
            .catch(error => {
                console.log(error)
                swal(LocService.t("label_error"), error.data.localized_error_message, 'error')
            })
    });

}


function getChipClassExpire(item){
    if(this.expireFromMonths === item.number){
        return 'chip-selected'
    }
    return 'chip-unselected'
}

function isSelectedExpire(item){
    return this.expireFromMonths === item.number
}

function onClickExpireMonth(item){
    if(this.expireFromMonths === item.number){
        this.expireFromMonths = null;
    }else{
        this.expireFromMonths = item.number;
    }
    this.load();
}

function getChipClassLoyalty(item){
    if (this.selectedLoyalties.includes(item)) {
        return 'chip-selected'
    }
    return 'chip-unselected'
}


function isSelectedLoyalty(item){
    return this.selectedLoyalties.includes(item)
}

function clickSelectLoyalty(item){
    if (this.selectedLoyalties.includes(item)) {
        this.selectedLoyalties = []
    } else {
        this.selectedLoyalties = []
        this.selectedLoyalties.push(item)
    }
    this.load();
}

function getChipClassCustomCategory(item) {
    if (this.selectedCustomCategories.includes(item)) {
        return 'chip-selected'
    }
    return 'chip-unselected'
}

function isSelectedCustomCategory(item) {
    return this.selectedCustomCategories.includes(item)
}

function clickSelectCustomCategory(item) {
    if (this.selectedCustomCategories.includes(item)) {
        this.selectedCustomCategories = []
    } else {
        this.selectedCustomCategories = []
        this.selectedCustomCategories.push(item)
    }
    this.load();
}

function externalPartnerPdf(){
    if(this.selectedPartnerCompany == null) return
    var currentDay = this.$moment(Date.now()).format('DD-MM-YYYY')
    var mainBody = [];
    mainBody.push([{text: 'Ime korisnika', style: 'miniHeaderTable2'}, {text: 'Datum registracije', style: 'miniHeaderTable2'}, {text: 'Zadnja aktivnost', style: 'miniHeaderTable2'}])
    for(var i =0; i < this.filteredUsers.length; i++){
       var createdDate = this.filteredUsers[i].createdTimestamp != null ? this.formatDate(this.filteredUsers[i].createdTimestamp): '-';
       var lastActivity = this.filteredUsers[i].lastActivity != null ? this.formatDate(this.filteredUsers[i].lastActivity): '-';
        mainBody.push([{text: this.filteredUsers[i].name + ' ' + this.filteredUsers[i].surname, style: 'miniHeaderTable2'}, {text: createdDate, style: 'miniHeaderTable2'}, {text: lastActivity, style: 'miniHeaderTable2'}])

    }
    pdfMake.vfs = pdfFonts.pdfMake.vfs;
    var dd = {
        content: [
            {text: this.selectedPartnerCompany, style: 'header'},
            {text: 'Ukupno korisnika: ' + this.filteredUsers.length, style: 'miniHeaderTable3'},
            {text: '', style: 'header'},
            {
                style: 'miniTableExample',
                table: {
                    headerRows: 1,
                    widths: ['auto', 'auto', 'auto'],
                    body: mainBody
                },
                layout: 'lightHorizontalLines'
            },

        ],
        styles: {
            header: {
                fontSize: 18,
                bold: true,
                margin: [0, 0, 0, 10]
            },
            headerRacun: {
                fontSize: 36,
                bold: true,
                margin: [0, 0, 0, 10]
            },
            subheader: {
                fontSize: 16,
                bold: true,
                margin: [0, 10, 0, 5]
            },
            companyInfo: {
                fontSize: 9,
                margin: [0, 10, 0, 5]
            },
            mainHeaderTable: {
                fontSize: 10,
                bold: true,
                margin: [0, 0, 0, 0]
            },
            mainRowTable: {
                fontSize: 10,
                margin: [0, 0, 0, 0]
            },
            miniHeaderTable: {
                fontSize: 8,
                bold: true,
                margin: [0, 0, 0, 0]
            },
            miniRowTable: {
                fontSize: 8,
                margin: [0, 0, 0, 0]
            },

            miniHeaderTable2: {
                fontSize: 12,
                bold: true,
                margin: [0, 0, 0, 0]
            },
            miniHeaderTable3: {
                fontSize: 14,
                bold: true,
                margin: [0, 0, 0, 0]
            },
            miniRowTable2: {
                fontSize: 12,
                margin: [0, 0, 0, 0]
            },

            tableExample: {
                margin: [0, 5, 0, 15]
            },
            miniTableExample: {
                margin: [0, 2, 0, 2]
            },
            tableHeader: {
                bold: true,
                fontSize: 13,
                color: 'black'
            }
        },

    }
    var fileName = this.selectedPartnerCompany +'-'+ currentDay;
    pdfMake.createPdf(dd).download(fileName)
}

function onChangeCheckUser(user){
    let isChecked = document.getElementById(user.id).checked
    if(!isChecked){
        this.selectedUsers = this.selectedUsers.filter(u => u.id !== user.id)
        this.selectedUsersIds = this.selectedUsersIds.filter(u => u !== user.id)
        var userF = this.users.find(u => u.id === user.id);
        if(userF != null){
            userF.checked = false;
        }
    }else{
        this.selectedUsers.push(user);
        this.selectedUsersIds.push(user.id);
        var userF = this.users.find(u => u.id === user.id);
        if(userF != null){
            userF.checked = true;
        }
    }
}

function setSelectedCheckUser(user){
    return this.selectedUsersIds.includes(user.id)
}

function reset(){
    this.messageTitle = ""
    this.messageText = ""
    this.selectedUsersIds = []
    this.selectedUsers = []
    this.sendByEmail = false
    this.sendByNotification = false
}

function sendCampaign(){
    const title = this.messageTitle != null ? this.messageTitle.trim() : '';
    const message = this.messageText != null ? this.messageText.trim() : '';

    if(this.selectedUsersIds.length === 0){
        swal(LocService.t('label_error'), LocService.t('label_campaign_error_no_users_selected'), 'warning')
        return;
    }

    if(title.length === 0){
        swal(LocService.t('label_error'), LocService.t('label_campaign_error_title_required'), 'warning')
        return;
    }

    if(message.length === 0){
        swal(LocService.t('label_error'), LocService.t('label_campaign_error_message_required'), 'warning')
        return;
    }

    let _self = this;
    let model = {
        title: title,
        text: message,
        userIds: this.selectedUsersIds,
        sentByEmail: this.sendByEmail,
        sentByPush: this.sendByNotification
    }

    AdminApiService.createCampaign(model)
        .then((response) => {
            swal(LocService.t('label_success'), LocService.t('label_success'), 'success')
            _self.reset()
        })
        .catch(error => {
            swal(LocService.t('label_error'), error.data.localized_error_message, 'error')
        })

}

function isAnyFilterActive(){
    return (this.filter != null && this.filter.trim().length > 0) ||
        this.debtor === true ||
        this.expireFromMonths != null ||
        this.selectedCustomCategories.length > 0 ||
        this.selectedLoyalties.length > 0 ||
        this.selectedGender != null ||
        this.selectedPartnerCompany != null;
}

function resetFilters(){
    this.filter = '';
    this.debtor = false;
    this.expireFromMonths = null;
    this.selectedCustomCategories = [];
    this.selectedLoyalties = [];
    this.selectedGender = null;
    this.selectedPartnerCompany = null;
    this.pagination.page = 1;
    this.load();
}



// WEBPACK FOOTER //
// ./src/components/Campaign/Campaign.js